import { render, staticRenderFns } from "./HizmetDetay.vue?vue&type=template&id=6ca5daaf&scoped=true&"
import script from "./HizmetDetay.vue?vue&type=script&lang=js&"
export * from "./HizmetDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5daaf",
  null
  
)

export default component.exports